import React from 'react';
import { dataHooks, PUBLISH_DATE_JUST_NOW } from '../constants';
import { SocialPostPreviewProps } from '../SocialPostPreview.types';
import { classes } from './InstagramPost.st.css';
import { Avatar, Text } from '../..';

export const InstagramPost: React.FC<
  Pick<
    SocialPostPreviewProps,
    'profileName' | 'profileImageSrc' | 'caption' | 'media'
  >
> = ({ profileName, profileImageSrc, caption, media }) => {
  const _renderAccountDetails = () => (
    <div className={classes.postHeader}>
      <Avatar
        size="size24"
        imgProps={{ src: profileImageSrc }}
        dataHook={dataHooks.socialPostPreviewProfileImage}
      />
      <Text
        size="tiny"
        weight="normal"
        dataHook={dataHooks.socialPostPreviewProfileName}
      >
        {profileName}
      </Text>
    </div>
  );

  const _renderMedia = () => (
    <div data-hook={dataHooks.socialPostPreviewMedia}>{media}</div>
  );

  const _renderCaptionAndPublishDate = () => (
    <div className={classes.postCaption}>
      {caption && (
        <>
          <Text size="tiny" weight="bold">
            {profileName}
          </Text>
          <Text dataHook={dataHooks.socialPostPreviewCaption} size="tiny">
            {caption}
          </Text>
        </>
      )}
      <Text skin="disabled" size="tiny">
        {PUBLISH_DATE_JUST_NOW}
      </Text>
    </div>
  );

  return (
    <>
      {_renderAccountDetails()}
      {_renderMedia()}
      {_renderCaptionAndPublishDate()}
    </>
  );
};
